
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AssignStaffToMatchPayload": [
      "AssignStaffToMatchErrorNotAuthorityPayload",
      "AssignStaffToMatchSuccessPayload"
    ],
    "AuthzPolicyAction": [
      "AnyAuthzPolicyAction",
      "ReadRoomAuthzPolicyAction"
    ],
    "AuthzPolicyPrincipal": [
      "AnyAuthzPolicyPrincipal",
      "StaffAuthzPolicyPrincipal",
      "TeamAuthzPolicyPrincipal"
    ],
    "AuthzPolicyResource": [
      "AnyAuthzPolicyResource",
      "RoomAuthzPolicyResource"
    ],
    "AvailableBookingRequestTimeSlotsPayload": [
      "AvailableBookingRequestTimeSlotsErrorInvalidCalendarConnection",
      "AvailableBookingRequestTimeSlotsErrorNoCalendarConnected",
      "AvailableBookingRequestTimeSlotsSuccess"
    ],
    "AvailableTimeSlotsPayload": [
      "AvailableTimeSlotsErrorNotAvailable",
      "AvailableTimeSlotsSuccess"
    ],
    "BaseError": [],
    "BookWithCalendarByEntrancePayload": [
      "BookWithCalendarByEntranceErrorAlreadyReserved",
      "BookWithCalendarByEntranceErrorV2User",
      "BookWithCalendarByEntranceSuccess"
    ],
    "BookingPayload": [
      "Booking",
      "BookingErrorNotFound",
      "BookingErrorPermissionDenined"
    ],
    "CalendarDetailPayload": [
      "CalendarDetailNotFound",
      "CalendarDetailPermissionDenied",
      "CalendarDetailSuccess"
    ],
    "CalendarQuestion": [
      "CalendarQuestionSelectBox",
      "CalendarQuestionText"
    ],
    "ChatMessageSendingJobMessage": [
      "ChatMessageSendingJobMessageImage",
      "ChatMessageSendingJobMessageQuestion",
      "ChatMessageSendingJobMessageText"
    ],
    "Condition": [
      "SegmentConditionClickURLCondition",
      "SegmentConditionEnqueteAnswered",
      "SegmentConditionInflowSource",
      "SegmentConditionLoginLink",
      "SegmentConditionRoomStatus"
    ],
    "CreateAuthzPolicyPayload": [
      "CreateAuthzPolicySuccessPayload"
    ],
    "CreateAutoChatReplySettingPayload": [
      "AutoChatReplySettingDuplicateKeywordError",
      "SaveAutoChatReplySettingSuccess"
    ],
    "CreateConditionalIntroductionMessagePayload": [
      "AlreadyExistsConditionalIntroductionMessageError",
      "SaveIntroductionMessageSuccess"
    ],
    "CreateLineRichMenuPayload": [
      "CreateLineRichMenuSuccessPayload",
      "LineRichMenuErrorPayload"
    ],
    "CreateStaffPayload": [
      "CreateStaffErrorAlreadyExistsPayload",
      "CreateStaffSuccessPayload"
    ],
    "CreateTeamPayload": [
      "CreateTeamSuccessPayload"
    ],
    "DeleteAuthzPolicyPayload": [
      "DeleteAuthzPolicySuccessPayload"
    ],
    "DeleteCalendarPayload": [
      "CalendarInUseByScheduleAdjustmentError",
      "DeleteCalendarSuccess"
    ],
    "DeleteChatMessageSendingJobPayload": [
      "DeleteChatMessageSendingJobErrorPayload",
      "DeleteChatMessageSendingJobSuccessPayload"
    ],
    "DeleteScenarioChatV2Payload": [
      "DeleteScenarioChatErrorAssociatedWithIntroductionMessage",
      "DeleteScenarioChatSuccess"
    ],
    "DeleteStaffPayload": [
      "DeleteStaffSuccessPayload"
    ],
    "DeleteTeamPayload": [
      "DeleteTeamSuccessPayload"
    ],
    "Error": [
      "UnknownError"
    ],
    "IntroductionMessageContent": [
      "PlainIntroductionMessageContent",
      "ScenarioChatIntroductionMessageContent"
    ],
    "IssueLoginLinkURLFromCSVPayload": [
      "IssueLoginLinkURLFromCSVErrorProviderNotFoundPayload",
      "IssueLoginLinkURLFromCSVSuccessPayload"
    ],
    "IssueLoginLinkURLWithIDGenerationPayload": [
      "IssueLoginLinkURLWithIDGenerationErrorProviderNotFoundPayload",
      "IssueLoginLinkURLWithIDGenerationSuccessPayload"
    ],
    "KartePlannerCommentMonthlyAmount": [
      "ManageOnlyFreePlanKartePlannerCommentMonthlyAmount",
      "V2021_1KartePlannerCommentMonthlyAmount",
      "V2022_1KartePlannerCommentMonthlyAmount",
      "V2023_1KartePlannerCommentMonthlyAmount"
    ],
    "LineMessagingCurrentMonthQuota": [
      "LineMessagingCurrentMonthQuota_Limited",
      "LineMessagingCurrentMonthQuota_None"
    ],
    "MatchStatusesInSameBranchPayload": [
      "MatchStatusesInSameBranchErrorNotAuthorityPayload",
      "MatchStatusesInSameBranchSuccessPayload"
    ],
    "MatchStatusesInSameCorporationPayload": [
      "MatchStatusesInSameCorporationErrorNotAuthorityPayload",
      "MatchStatusesInSameCorporationSuccessPayload"
    ],
    "PostKartePlannerCommentMutationPayload": [
      "PostKartePlannerCommentMutationErrorPayload",
      "PostKartePlannerCommentMutationSuccessPayload"
    ],
    "RemoveConditionalIntroductionMessagePayload": [
      "SaveIntroductionMessageSuccess"
    ],
    "RemoveUserVariableDefinitionValueSelectOptionPayload": [
      "RemoveUserVariableDefinitionValueSelectOptionErrorPayload",
      "RemoveUserVariableDefinitionValueSelectOptionSuccessPayload"
    ],
    "RevokePlannerAccountThirdpartyOAuthCredentialsPayload": [
      "RevokePlannerAccountThirdpartyOAuthCredentialsSuccessPayload"
    ],
    "SaveDefaultIntroductionMessagePayload": [
      "SaveIntroductionMessageSuccess"
    ],
    "ScenarioChatMessageSelectionAction": [
      "ScenarioChatMessageSelectionActionAssignPlannerAccountToMatch"
    ],
    "ScenarioChatMessageSelections": [
      "ScenarioChatMessageBasicSelections",
      "ScenarioChatMessageBookingRequestSelections"
    ],
    "ScheduleChatMessageSendingJobPayload": [
      "ScheduleChatMessageSendingJobErrorPayload",
      "ScheduleChatMessageSendingJobSuccessPayload"
    ],
    "SimpleLifePlanningLifeEvent": [
      "EducationEvent",
      "UserEvent"
    ],
    "SolicitorCloudDocument": [
      "SolicitorCloudCoverageDocument",
      "SolicitorCloudPamphletDocument"
    ],
    "StorePlannerAccountOAuthCredentialPayload": [
      "StorePlannerAccountOAuthCredentialSuccessPayload"
    ],
    "UnassignStaffFromMatchPayload": [
      "UnassignStaffFromMatchErrorNotAuthorityPayload",
      "UnassignStaffFromMatchSuccessPayload"
    ],
    "UpdateAuthzPolicyPayload": [
      "UpdateAuthzPolicySuccessPayload"
    ],
    "UpdateAutoChatReplySettingPayload": [
      "AutoChatReplySettingDuplicateKeywordError",
      "SaveAutoChatReplySettingSuccess"
    ],
    "UpdateConditionalIntroductionMessagePayload": [
      "AlreadyExistsConditionalIntroductionMessageError",
      "SaveIntroductionMessageSuccess"
    ],
    "UpdateLineRichMenuPayload": [
      "LineRichMenuErrorPayload",
      "UpdateLineRichMenuSuccessPayload"
    ],
    "UpdateLoginLinkRedirectURIPayload": [
      "UpdateLoginLinkRedirectURISuccessPayload"
    ],
    "UpdateScheduledTimeOfChatMessageSendingJobPayload": [
      "UpdateScheduledTimeOfChatMessageSendingJobErrorPayload",
      "UpdateScheduledTimeOfChatMessageSendingJobSuccessPayload"
    ],
    "UpdateStaffPayload": [
      "UpdateStaffErrorNotAuthorityPayload",
      "UpdateStaffSuccessPayload"
    ],
    "UpdateStaffProfilePayload": [
      "UpdateStaffProfileSuccessPayload"
    ],
    "UpdateTeamPayload": [
      "UpdateTeamSuccessPayload"
    ],
    "UserKartePayload": [
      "Karte",
      "UserKarteErrorPermissionDenied"
    ],
    "UserVariableDefinitionValue": [
      "UserVariableDefinitionValueMultipleSelect",
      "UserVariableDefinitionValueSelect",
      "UserVariableDefinitionValueString",
      "UserVariableDefinitionValueText"
    ],
    "UserVariableValue_Value": [
      "UserVariableValue_ValueMultipleSelect",
      "UserVariableValue_ValueSelect",
      "UserVariableValue_ValueString",
      "UserVariableValue_ValueText"
    ]
  }
};
      export default result;
    